/** @format */

import React from 'react';
import Link from 'components/global/Link';
import urls from 'utils/urls';
import logopic from './logo.png';
import Logo from './Logo';
import Media from 'react-media';
import { getPaths } from './paths';
import theme from 'theme';
import ReactCollapsible from 'react-collapsible';
import ScrollToTop from 'components/global/ScrollToTop';
const EXCESS_WIDTH = 100;

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hamburgerMenuInTransition: false,
      hamburgerMenuOpen: this.props.showHamburgerMenu
    };
  }
  componentDidUpdate(prevProps) {
    const paths = getPaths(this.props);
    const currentPath = paths.find(
      (path) => path.pathname === this.props.browserPath
    );

    if (this.props.browserPath !== prevProps.browserPath) {
      this.props.closeExpandedMenus();
    }

    if (
      window.innerWidth < theme.desktopSmallInt &&
      currentPath &&
      currentPath.parentId &&
      !prevProps.expandedNavigationItems.includes(currentPath.parentId) &&
      !this.props.expandedNavigationItems.includes(currentPath.parentId)
    ) {
      this.props.addExpandedItem(currentPath.parentId);
    }

    if (this.props.showHamburgerMenu && !prevProps.showHamburgerMenu) {
      setTimeout(
        () => window.addEventListener('click', prevProps.closeHamburgerMenu),
        0
      );
    } else if (!this.props.showHamburgerMenu && prevProps.showHamburgerMenu) {
      window.removeEventListener('click', prevProps.closeHamburgerMenu);
    }

    if (
      !this.state.hamburgerMenuInTransition &&
      this.state.hamburgerMenuOpen !== this.props.showHamburgerMenu
    ) {
      this.setState({
        hamburgerMenuInTransition: true,
        hamburgerMenuOpen: this.props.showHamburgerMenu
      });
    }
  }
  componentWillUnmount() {
    this.props.closeHamburgerMenu();
    window.removeEventListener('click', this.props.closeHamburgerMenu);
  }

  render() {
    const {
      hideLinks,
      openHamburgerMenu,
      browserPath,
      checkedSession,
      isChecking,
      organizationLogo,
      expandedNavigationItems
    } = this.props;
    const paths = hideLinks ? [] : getPaths(this.props);
    let hamburgerItems = 0;
    let visibleItems = 0;
    const standardDesktopItems = 4;
    const excessDesktopNavigationItems = [];

    paths
      .filter((path) => !path.hidden && !path.alwaysHamburger)
      .reverse()
      .forEach((path, i) => {
        if (i >= standardDesktopItems) excessDesktopNavigationItems.push(path);
      });

    const navigationItems = paths
      .filter((path) => {
        return path.hidden || path.isExpandItem ? false : true;
      })
      .reverse()
      .map((path, i) => {
        const pathRegexp = new RegExp(`^/${path.pathname.split('/')[1]}`);
        const selected = pathRegexp.test(browserPath) ? ' selected' : '';
        const hidden = path.hidden ? ' hidden' : '';
        const onlyMobile = path.onlyMobile ? ' only-mobile' : '';
        const even = !path.hidden && visibleItems % 2 === 0 ? ' even' : '';
        visibleItems = path.hidden ? visibleItems : visibleItems + 1;
        let accentColor = '';
        let alwaysHamburger = '';
        if (path.alwaysHamburger) {
          hamburgerItems++;
          alwaysHamburger = ' always-hamburger';
          accentColor = hamburgerItems % 2 === 0 ? ' accent-color' : '';
        }
        const classNames = `navigation-item${even}${selected}${hidden}${accentColor}${alwaysHamburger}${onlyMobile}`;
        const isExcessItem = excessDesktopNavigationItems.find((item) => {
          return item.name === path.name;
        });
        const clickHandler = (e) => {
          if (typeof path.onClick === 'function') {
            if (path.expandable) {
              path.onClick(path);
            } else {
              path.onClick();
            }
            if (!path.pathname) {
              e.preventDefault();
            }
          }
        };

        if (path.expandable) {
          return renderExpandableNavigationItem({
            paths,
            path,
            browserPath,
            isExcessItem,
            classNames,
            clickHandler,
            index: i,
            expandedNavigationItems
          });
        } else if (isExcessItem) {
          return renderExcessNavigationItems({
            path,
            classNames,
            clickHandler,
            index: i
          });
        } else {
          return (
            <div className={classNames} key={i}>
              <Link to={path.pathname} onClick={clickHandler}>
                {path.name}
              </Link>
            </div>
          );
        }
      });

    let logoPath = isChecking ? '' : logopic;
    if (checkedSession) {
      logoPath = organizationLogo || logopic;
    }

    return (
      <div>
        <ScrollToTop />
        <div className='navigation-bar-wrapper'>
          <div className='navigation-bar'>
            <Link to={urls.home}>{<Logo logoPath={logoPath} />}</Link>
            <div className='desktop-navigation-items'>{navigationItems}</div>
            {!hideLinks && (
              <span
                className='fa fa-bars hamburger-menu-button'
                onClick={openHamburgerMenu}
              />
            )}
          </div>
          <ReactCollapsible
            transitionTime={200}
            easing='ease-in-out'
            overflowWhenOpen='visible'
            open={this.state.hamburgerMenuOpen}
            className={`hamburger-navigation-items`}
            openedClassName={`hamburger-navigation-items`}
            onClose={() =>
              this.setState({
                hamburgerMenuInTransition: false,
                hamburgerMenuOpen: false
              })
            }
            onOpen={() =>
              this.setState({
                hamburgerMenuInTransition: false,
                hamburgerMenuOpen: true
              })
            }
          >
            {navigationItems}
          </ReactCollapsible>
        </div>
      </div>
    );
  }
}

function renderExpandableNavigationItem({
  paths,
  path,
  browserPath,
  isExcessItem,
  classNames,
  clickHandler,
  index,
  expandedNavigationItems
}) {
  const breakPoint = isExcessItem
    ? theme.desktopSmallInt + EXCESS_WIDTH
    : theme.desktopSmallInt;
  const childItems = paths
    .filter((childPath) => childPath.parentId === path.id)
    .map((childPath, childIndex) => {
      const expandItem = childPath.isExpandItem ? ' expand-item' : '';
      const selected = browserPath === childPath.pathname ? ' selected' : '';
      return (
        <div
          className={`navigation-item${expandItem}${selected}`}
          key={childIndex}
        >
          <Link to={childPath.pathname} onClick={clickHandler}>
            {childPath.name}
          </Link>
        </div>
      );
    });

  const isExpanded = expandedNavigationItems.find(
    (expandedNavItem) => expandedNavItem === path.id
  );
  return (
    <React.Fragment key={index}>
      <Media
        query={`(max-width: ${breakPoint}px)`}
        render={() => (
          <React.Fragment>
            <div
              id='expandable'
              role='button'
              className={`${classNames} always-hamburger`}
              key={index}
              to={path.pathname}
              onClick={clickHandler}
            >
              <p id='expandable'>{path.name}</p>
              <React.Fragment>
                <Media
                  query={`(max-width: ${theme.desktopSmallInt}px)`}
                  render={() => (
                    <i
                      id='expandable'
                      className={'fa fa-caret-'.concat(
                        isExpanded ? 'down' : 'up'
                      )}
                    />
                  )}
                />
              </React.Fragment>
            </div>
            <div>{isExpanded && childItems}</div>
          </React.Fragment>
        )}
      />
      <Media
        query={`(min-width: ${breakPoint}px)`}
        render={() => (
          <div
            id='expandable'
            className={classNames}
            key={index}
            onClick={clickHandler}
          >
            <ul>
              <li>
                <div
                  id='expandable'
                  role='button'
                  className='navigation-link'
                  to={path.pathname}
                >
                  {path.name}
                </div>
                <React.Fragment>
                  <Media
                    query={`(min-width: ${theme.desktopSmallInt}px)`}
                    render={() => (
                      <i
                        id='expandable'
                        className={'fa fa-caret-'.concat(
                          isExpanded ? 'down' : 'up'
                        )}
                      />
                    )}
                  />
                </React.Fragment>
              </li>
              {isExpanded && <li> {childItems}</li>}
            </ul>
          </div>
        )}
      />
    </React.Fragment>
  );
}

function renderExcessNavigationItems({
  path,
  classNames,
  clickHandler,
  index
}) {
  const breakPoint = theme.desktopSmallInt + EXCESS_WIDTH;
  return (
    <div key={index}>
      <Media
        query={`(max-width: ${breakPoint}px)`}
        render={() => (
          <div className={`${classNames} always-hamburger`} key={index}>
            <Link to={path.pathname} onClick={clickHandler}>
              {path.name}
            </Link>
          </div>
        )}
      />
      <Media
        query={`(min-width: ${breakPoint}px)`}
        render={() => (
          <div className={`${classNames}`} key={index}>
            <Link to={path.pathname} onClick={clickHandler}>
              {path.name}
            </Link>
          </div>
        )}
      />
    </div>
  );
}

export default NavigationBar;
